var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.0007 9.33333C10.8961 9.33333 10.0007 8.4379 10.0007 7.33333C10.0007 6.22876 10.8961 5.33333 12.0007 5.33333C13.1052 5.33333 14.0007 6.22876 14.0007 7.33333C14.0007 8.4379 13.1052 9.33333 12.0007 9.33333ZM6.00065 7.33333C4.52789 7.33333 3.33398 6.13943 3.33398 4.66667C3.33398 3.19391 4.52789 2 6.00065 2C7.47341 2 8.66732 3.19391 8.66732 4.66667C8.66732 6.13943 7.47341 7.33333 6.00065 7.33333Z",
    fill: "#0078D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7341 9.99976C14.0051 10.0246 15.8595 11.1728 15.999 13.5993C16.0046 13.6971 15.999 13.9993 15.6373 13.9993H13.0667C13.0667 12.4987 12.5709 11.1139 11.7341 9.99976ZM0.000434456 13.4655C0.258839 10.2837 2.84127 8.66602 5.98889 8.66602C9.18081 8.66602 11.8033 10.1948 11.9986 13.466C12.0064 13.5963 11.9986 13.9993 11.4978 13.9993C9.02742 13.9993 5.35648 13.9993 0.485001 13.9993C0.317808 13.9993 -0.0136412 13.6388 0.000434456 13.4655Z",
    fill: "#0078D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleActive);
export default __webpack_public_path__ + "static/media/people_active.c064994d.svg";
export { ForwardRef as ReactComponent };